import { useTranslation } from '@wix/wix-i18n-config';
import { Loader } from '@wix/design-system';
import cs from 'classnames';
import React from 'react';

import { templatePreviewModalDataHooks } from '../TemplatePreviewModal.dataHooks';
import s from './PreviewHeader.scss';
import WixStudioLogo from './WixStudioLogo.svg';
import Desktop from './Desktop.svg';
import StudioLogoIcon from './StudioLogoIcon.svg';
import DesktopIcon from './DesktopIcon.svg';
import { useIsStudio2Ui } from '../../../hooks/useIsStudio2Ui';

type Props = {
  onButtonClick: () => void;
  isLoading?: boolean;
  isStudioMobileFlow?: boolean;
};

export const PreviewHeader: React.FC<Props> = ({
  onButtonClick,
  isLoading,
  isStudioMobileFlow,
}) => {
  const { t } = useTranslation();
  const isStudio2Ui = useIsStudio2Ui();

  const buttonTextKey = isStudioMobileFlow
    ? 'app.templates.ChooseTemplate.ChooseButton.text'
    : 'app.templates.saveTemplate.saveButton.text';

  return (
    <>
      <div
        className={s.previewHeader}
        data-hook={templatePreviewModalDataHooks.previewHeader()}
      >
        {isStudio2Ui ? (
          <span className={s.studio2Logo}>
            <StudioLogoIcon />
            Wix Studio
          </span>
        ) : (
          <WixStudioLogo className={s.logo} />
        )}
        <button
          onClick={onButtonClick}
          disabled={isLoading}
          className={cs(s.button, s.buttonWrap)}
        >
          {isLoading && (
            <span className={s.buttonLoader}>
              <Loader size="tiny" />
            </span>
          )}
          <span className={cs({ [s.buttonLabelHidden]: isLoading })}>
            {t(buttonTextKey)}
          </span>
        </button>
      </div>
      <div className={s.goToDesktop}>
        {isStudio2Ui ? <DesktopIcon /> : <Desktop />}
        <div>{t('app.template.viewer.goToBiggerScreen')}</div>
      </div>
    </>
  );
};
